import { render, staticRenderFns } from "./Ocupacion.vue?vue&type=template&id=215621c8&"
import script from "./Ocupacion.vue?vue&type=script&lang=js&"
export * from "./Ocupacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports